export class PartnerModel {
  token!: string;
  refreshToken!: string;

  setAuth(auth: PartnerModel) {
    this.token = auth.token;
    this.refreshToken = auth.refreshToken;
  }
}
